import React, { useEffect, useMemo, useState } from 'react';
import useOrganizations from '../../../hooks/system/query/useOrganizations';
import { MovaticFieldGroupAsyncSelect } from '../../../components/Redesing/movatic-field-group';
import { Option } from '../../../ts/interface/components/table.interface';

function OrganizationSelect({
  onChange,
  value,
}: {
  onChange: (value: Option | null) => void;
  value: Option | null;
}) {
  const { data, isLoading, refetch: refetchOrganizations } = useOrganizations();

  const [openAsyncSelect, setOpenAsyncSelect] = useState(false);

  useEffect(() => {
    if (openAsyncSelect) {
      refetchOrganizations();
    }
  }, [openAsyncSelect, refetchOrganizations]);

  const organizationOptions = useMemo(() => {
    return data?.data?.map((organization: { id: string; name: string }) => ({
      label: organization.name,
      value: organization.id,
    }));
  }, [data]);

  return (
    <MovaticFieldGroupAsyncSelect
      isLoading={isLoading}
      id={'organization'}
      label="Organization"
      name={'organization'}
      description="Required"
      options={organizationOptions || []}
      value={value}
      // showClearButton
      onChange={(event: any, newValue: any) => onChange(newValue)}
      open={openAsyncSelect}
      onOpen={() => {
        setOpenAsyncSelect(true);
      }}
      onClose={() => {
        setOpenAsyncSelect(false);
      }}
      isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
      getOptionText={(option: any) => option?.label || "N/A"}
      handleSearch={() => {}}
    />
  );
}

export default OrganizationSelect;
